import { z } from "zod";
import type { BaseFile } from "./base-file.ts";

export const baseFileSchema = z.object({
  path: z.string(),
  fileName: z.string(),
  mimeType: z.string(),
}) satisfies z.ZodType<BaseFile>;
